<template>
  <div class="main_box">
    <div class="title">
      <h1>{{$t("lang.ourToken")}}<span> RTV</span></h1>
    </div>
    <div class="swap-body">
      <div class="k-line">
<!--        <div class="time-controls">-->
<!--          &lt;!&ndash; Supported intervals: 1d (daily), 1w (7 days), 1m (30 days), 1y (365 days) &ndash;&gt;-->
<!--          <button-->
<!--              v-for="interval in intervals"-->
<!--              :key="interval"-->
<!--              @click="setInterval(interval)"-->
<!--              :class="{ active: interval === currentInterval }"-->
<!--          >-->
<!--            {{ interval }}-->
<!--          </button>-->
<!--        </div>-->
        <!-- ECharts candlestick chart component -->
        <v-chart
            ref="kChart"
            :options="chartOptions"
            :auto-resize="true"
            style="width: 100%; height: 600px;"
            class="kline-chart"
        />
      </div>
      <div class="swap-rapper">
        <iframe
            src="https://app.uniswap.org/swap?inputCurrency=ETH&outputCurrency=0x61e24Ce4efe61EB2efd6AC804445df65f8032955"
            height="600px"
            width="100%"
            style="
          border: 0;
          margin: 0 auto;
          display: block;
          border-radius: 20px;
        "
        />
      </div>
    </div>
  </div>

</template>

<script>
import { use } from 'echarts/core'
import { CandlestickChart } from 'echarts/charts'
import { GridComponent, TooltipComponent, DataZoomComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import VChart, { THEME_KEY } from "vue-echarts";
import {THE_GRAPH_API} from "@/config";
import LineChart from "@/views/account/modules/lineChart.vue";
import CandleChart from "@/views/modules/candleChart.vue";

use([
  CandlestickChart,
  GridComponent,
  TooltipComponent,
  DataZoomComponent,
  CanvasRenderer
])

export default {
  name: 'IndexSwap',
  components: {
    CandleChart,
    LineChart,
    'v-chart': VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },
  watch: {
    chartOptions: {
      handler() {
        this.$refs.kChart.setOption(this.chartOptions)
      },
      deep: true
    }
  },
  data() {
    return {
      // Define fixed day-based intervals
      intervals: ['1d', '1w', '1m'],
      currentInterval: '1w', // default grouping: 1-week candle (7 days)
      chartOptions: {
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            if (!params.length) return ''
            // In v5, the params array is similar to v4.
            // seriesType should still be available:
            const candle = params.find(p => p.seriesType === 'candlestick')
            if (!candle) return ''
            const [open, close, low, high] = candle.data
            const time = candle.axisValueLabel
            return (
                `${time}<br/>` +
                `Open: ${open} &nbsp; Close: ${close}<br/>` +
                `Low: ${low} &nbsp; High: ${high}`
            )
          }
        },
        grid: {
          left: '10%',
          right: '8%',
          top: '10%',
          bottom: '15%'
        },
        xAxis: {
          type: 'category',
          data: [], // Will hold date labels (YYYY-MM-DD)
          boundaryGap: true
        },
        yAxis: {
          type: 'value',
          scale: true,
          boundaryGap: [0.01, 0.01]
        },
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0],
            throttle: 50
          },
          {
            type: 'slider',
            xAxisIndex: [0],
            top: '90%',
            height: 20
          }
        ],
        series: [
          {
            name: 'Price (USD)',
            type: 'candlestick',
            data: [] // Each item: [open, close, low, high]
          }
        ]
      },
      // Set your pair address (token/WETH pair)
      pairAddress: ''
    };
  },
  methods: {
    /**
     * Fetch pairDayDatas from Uniswap V2 and group them into candles.
     * Compute token price in USD as: (reserve1 * ethPrice) / reserve0.
     */
    async fetchChartData(interval) {
      try {
        // Map each interval to a number of days (group size)
        const intervalMap = {
          '2d': 1,
          '1w': 7,
          '1m': 30
        };
        const groupSize = intervalMap[interval] || 1;

        // Build GraphQL query to fetch:
        // 1. ETH price from the bundle entity.
        // 2. Daily data for the given pair from pairDayDatas.
        const query = {
          query: `{
            bundle(id: "1") {
              ethPrice
            }
            pairDayDatas(first: 1000, orderBy: date, orderDirection: asc, where: { pairAddress: "${this.pairAddress.toLowerCase()}" }) {
              date
              reserve0
              reserve1
            }
          }`
        };

        const response = await fetch(THE_GRAPH_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(query)
        });
        const result = await response.json();
        console.log('Subgraph response:', result);
        if (!result.data) {
          throw new Error("No data returned from subgraph");
        }
        const ethPrice = parseFloat(result.data.bundle.ethPrice);
        const dayDatas = result.data.pairDayDatas || [];

        // Compute daily USD price for token0 (assuming pair is token0/WETH)
        // priceUSD = (reserve1 * ethPrice) / reserve0
        const dailyPrices = dayDatas.map(dp => ({
          date: dp.date, // Unix timestamp (seconds)
          price: (parseFloat(dp.reserve1) * ethPrice) / parseFloat(dp.reserve0)
        }));
        // Group daily data points into candles based on the group size.
        const groupedCandles = [];
        const categoryData = [];
        let currentGroup = [];
        dailyPrices.forEach(dataPoint => {
          currentGroup.push(dataPoint);
          if (currentGroup.length === groupSize) {
            const prices = currentGroup.map(item => item.price);
            const open = prices[0];
            const close = prices[prices.length - 1];
            const high = Math.max(...prices);
            const low = Math.min(...prices);
            groupedCandles.push([open, close, low, high]);
            categoryData.push(this.formatDate(currentGroup[0].date));
            currentGroup = [];
          }
        });
        // Process any leftover data points.
        if (currentGroup.length > 0) {
          const prices = currentGroup.map(item => item.price);
          const open = prices[0];
          const close = prices[prices.length - 1];
          const high = Math.max(...prices);
          const low = Math.min(...prices);
          groupedCandles.push([open, close, low, high]);
          categoryData.push(this.formatDate(currentGroup[0].date));
        }

        // Update chart options and force re-render.
        this.chartOptions.xAxis.data = categoryData;
        this.chartOptions.series[0].data = groupedCandles;
        this.chartOptions = JSON.parse(JSON.stringify(this.chartOptions));
        console.log('categoryData:', categoryData);
        console.log('groupedCandles:', groupedCandles);
      } catch (err) {
        console.error('Failed to fetch chart data:', err);
      }

    },
    /** Format a Unix timestamp (in seconds) as YYYY-MM-DD */
    formatDate(ts) {
      const date = new Date(ts * 1000);
      return date.toISOString().slice(0, 10);
    },
    /** Handle clicking an interval button */
    setInterval(interval) {
      if (interval === this.currentInterval) return;
      this.currentInterval = interval;
      this.fetchChartData(interval);
    },
    handleResize() {
      this.$refs.kChart.resize();
    }
  },
  mounted() {
    // Set your pair address for the token/WETH pair (replace with your actual pair address)
    this.pairAddress = '0x877e453c453132f3f812984184a20241bba8dc39';
    // Fetch initial chart data using the default interval.
    this.fetchChartData(this.currentInterval);
    window.addEventListener('resize', this.handleResize);
    this.$refs.kChart.resize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped lang="less">
.title{
  justify-content: center;
  align-items: center;
  display: flex;
  h1 {
    font-size: 3rem;
    font-weight: 700;
    color: #333;
    margin-bottom: 20px;
    span{
      font-size: 4rem;
      background: linear-gradient(90deg, rgba(242, 106, 255, 1), rgba(125, 111, 255, 1));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    };
  }
}
.swap-body{
  padding-top: 20px;
  padding-bottom: 80px;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  .k-line{

    margin-right: 7.5px;
    width: 60%;
    height: 600px;
    border-radius: 20px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    position: relative;
    .time-controls {
      text-align: center;
    }
    .time-controls button {
      background: #f5f5f5;
      border: 1px solid #ccc;
      border-radius: 5px;
      width: 50px;
      color: #333;
      padding: 4px 8px;
      margin: 5px 5px 0px 5px;
      font-size: 0.9rem;
      cursor: pointer;
    }
    .time-controls button.active {
      background: #333;
      color: #fff;
      border-color: #333;
    }
    .kline-chart {
      width: 100%;
      height: 100%;
    }
    @media (min-width: 768px) {
      .chart-section {
        height: 500px;
      }
    }
  }
  .swap-rapper{
    margin-left: 7.5px;
    width: 40%;
    height: 600px;
    border-radius: 20px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  }
}

@media screen and (max-width: 991px) {
  .swap-body{
    max-width: 961px;
    margin-left: 15px;
    margin-right: 15px;
    display: flex;
    flex-direction: column;
    .k-line{
      margin: 0;
      margin-bottom: 7.5px;
      width: 100%;
      height: 600px;
    }
    .swap-rapper{
      margin: 0;
      margin-top: 7.5px;
      width: 100%;
      height: 600px;
    }
  }
}

@media screen and (max-width: 767px) {
  .swap-body{
    margin-left: 15px;
    margin-right: 15px;
    max-width: 1300px;
    display: flex;
  }
}
</style>